import User from '@/models/User'
import Trace from '@/models/Trace'

// Users

export async function getUserData (user) {
  await User.api().get('/api/users/' + user, {
    params: {
      query: '{ id, url, short_name, traces{-data} }'
    }
  })
}

export async function getUsers () {
  await User.api().get('/api/users', {
    dataKey: 'results',
    params: {
      query: '{ id, url, short_name }'
    }
  })
}

// Traces

export async function createTrace () {
  const newTrace = await Trace.api().post(
    '/api/traces'
  ).then((response) => {
    // Return the newly created trace object.
    return response.entities.traces[0]
  })

  return newTrace
}

export async function getTraces (user) {
  await User.api().get('/api/users/' + user, {
    params: {
      query: '{ id, traces{-url, -data} }'
    }
  })
}

export async function updateTrace (trace, data) {
  await Trace.api().put(
    '/api/traces/' + trace.id, data
  )
}

export async function deleteTrace (trace) {
  await Trace.api().delete(
    '/api/traces/' + trace.id, {
      delete: trace.id
    })
}

// Error handling

export function showApiErrorDialog (context, response, message) {
  if (!message) {
    message = 'Something went wrong!'
  }

  context.$buefy.dialog.alert({
    title: 'Error',
    message: `${message}
<p class="is-size-7 is-family-code has-text-danger">
 ${response}
</p>`,
    type: 'is-danger',
    hasIcon: true,
    icon: 'times-circle',
    ariaRole: 'alertdialog',
    ariaModal: true
  })
}

export default {
  getUserData,
  getUsers,
  createTrace,
  getTraces,
  updateTrace,
  deleteTrace,

  // Error handling
  showApiErrorDialog
}
